import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
// Unused imports removed; uncomment together with their routes if needed.
// import NagadAccountDetails from "../Component/Booknow Component/NagadAccountDetails";
// import Category from "./Category";
import Booknow from "./Booknow";
import ExpertList from "./ExpertList";
import Explore from "./Explore";
import Home from "./Home";
import ServiceList from "./ServiceList";
import UserType from "./UserType";
import ServiceDetails from "../Component/ServiceList Components/ServiceDetails/ServiceDetails";
import BlogList from "./BlogList";
import Blogdetails from "../Component/BlogList Components/Blogdetails";
import ProfileDetails from "../Component/Profile Components/ProfileDetails";
import JobDetails from "../Component/JobList Components/JobDetails";
import Footer from "../Component/Homepage Components/Footer/Footer";
import FooterBottom from "../Component/Homepage Components/Footer/FooterBottom";
import BookPage from "../Component/BookItem/BookPage";
import Quotation from "../Component/BookItem/Quotation/Quotation";
import SearchPage from "../Component/Search/SearchPage";
import PrivacyPolicy from "../Component/Homepage Components/Footer/PrivacyPolicy";
import Contact from "../Component/Homepage Components/Footer/Contact";
import Terms from "../Component/Homepage Components/Footer/Terms";
import About from "../Component/Homepage Components/Footer/About";
import ProfileAg from "../Component/Profile Components/ProfileAg";
import ServiceListExplore from "./ServiceListExplore";
import ExpertListExplore from "./ExpertListExplore";
import JobList from "./JobList";
import AgencyList from "./AgencyList";
import JobListExplore from "./JobListExplore";
import JobListAgency from "./JobListAgency";

// Bug fix: React Router keeps the previous scroll position on navigation, so
// opening a new page from the bottom of a long one (very common on phones)
// landed mid-page. Reset to the top whenever the path changes.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Bug fix: there was no fallback route, so unknown URLs rendered nothing.
// (Single-segment unknown paths like /abc still match "/:sopnoId" and are
// handled by ProfileDetails; this catches everything deeper, e.g. /a/b/c.)
const NotFound = () => (
  <Box
    sx={{
      textAlign: "center",
      px: 2,
      py: { xs: 8, md: 12 },
    }}
  >
    <Typography
      component="h1"
      sx={{ fontSize: { xs: "2rem", md: "3rem" }, fontWeight: 700, mb: 1 }}
    >
      Page not found
    </Typography>
    <Typography sx={{ color: "text.secondary", mb: 3 }}>
      The page you're looking for doesn't exist or has moved.
    </Typography>
    <Button component={Link} to="/" variant="contained">
      Back to home
    </Button>
  </Box>
);

const Pages = () => {
  return (
    // Column layout + minHeight keeps the footer at the bottom of the screen
    // on short pages (tablets/large phones in landscape). overflowX "clip"
    // stops any wide child from creating a sideways scrollbar on mobile
    // without breaking position: sticky.
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflowX: "clip",
      }}
    >
      <ScrollToTop />

      <Box component="main" sx={{ flex: "1 0 auto", width: "100%", minWidth: 0 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/:id" element={<Category />} /> */}
          <Route path="/usertype" element={<UserType />} />
          <Route path="/explore/:id" element={<Explore />} />
          <Route path="/servicelist" element={<ServiceList />} />
          <Route path="/servicelist/:refer" element={<ServiceListExplore />} />
          <Route path="/servicedetails/:refer" element={<ServiceDetails />} />
          <Route
            path="/jobDetails/:jobId/:jobRefer/:poid"
            element={<JobDetails />}
          />
          <Route path="/book/:refer" element={<BookPage />} />
          <Route path="/search/:type/:text" element={<SearchPage />} />
          <Route path="/quotation/:refer" element={<Quotation />} />
          <Route path="/joblist" element={<JobList />} />
          <Route path="/joblist/:refer" element={<JobListExplore />} />
          <Route path="/jobAgency/:agency" element={<JobListAgency />} />
          <Route path="/expertlist" element={<ExpertList />} />
          <Route path="/expertlist/:refer" element={<ExpertListExplore />} />
          <Route path="/agentlist" element={<AgencyList />} />
          <Route path="/agentlist/:refer" element={<AgencyList />} />
          <Route path="/bloglist" element={<BlogList />} />
          <Route path="/bloglist/:caten" element={<BlogList />} />
          <Route path="/blogdetails/:refer" element={<Blogdetails />} />
          <Route path="/profiledetails/:sopnoId" element={<ProfileDetails />} />
          <Route path="/:sopnoId" element={<ProfileDetails />} />
          <Route path="/profile/:sopnoId" element={<ProfileAg />} />
          <Route path="/booknow/:refer" element={<Booknow />} />
          {/* <Route path="/nagad" element={<NagadAccountDetails />} /> */}

          <Route path="/contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>

      <Box sx={{ marginTop: { xs: "24px", md: "40px" }, flexShrink: 0 }}>
        <Footer />
        <FooterBottom />
      </Box>
    </Box>
  );
};

export default Pages;